/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 管理端使用用户名密码获取token信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  mgmtTokenDto: oauth2.MgmtTokenDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oauth2.MgmtToken;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oauth2/token-mgmt-password`,
    data: mgmtTokenDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
